import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import badChoices from './commons/bad_choices.js'

const level = new Level({
    name: 'variables',
    dependencies: ['levels/_easy_maths']
})



level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(1, 5)
        let b = random.intBetween(1, 5)
        if (b === a) {
            b += 2
        }

        q.addCode({
            javascript: 'let a = ' + a + '\na + ' + b,
            python: 'a = ' + a + '\na + ' + b
        }, level.language)

        q.addBadChoices(badChoices.forSimpleMath(a, b))
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(1, 5)
        let b = random.intBetween(1, 5)
        if (b === a) {
            b += 2
        }

        q.addCode({
            javascript: 'let a = ' + a + '\nlet b = ' + b + '\na + b',
            python:     'a = ' + a + '\nb = ' + b + '\na + b'
        }, level.language)

        q.addBadChoices(badChoices.forSimpleMath(a, b))
    }
})


export default level

